import React from 'react';
import PropTypes from 'prop-types';

import { Paper, Checkbox, Dialog, RaisedButton } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import pallet from 'constants/colors';

const styles = {
  acceptContainer: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  agreementItem: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: 16,
    marginRight: 16,
    borderLeft: 'solid 10px #f5aa0a',
  },
  action: {
    margin: 8,
  },
  infoButton: {
    marginTop: 16,
  },
  warning: {
    fontSize: 14,
    color: pallet.errorColor,
  },
};

class Agreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      file: null,
    };
  }

  onCheck = () => {
    this.setState({ dialogOpen: true });
  }

  onAccept = () => {
    const { HrAgreementID, EmployeeDetailID, FileRepositoryObjectDocumentTypeID } = this.props;
    const { file } = this.state;
    this.props.handleAgreement(HrAgreementID, EmployeeDetailID, file, FileRepositoryObjectDocumentTypeID);
    this.handleClose();
  }

  handleClose = () => this.setState({ dialogOpen: false });

  handleFile = e => this.setState({ file: e.target.files[0] });

  render() {
    const {
      HrAgreementText,
      Link,
      FileRepositoryObjectDocumentTypeID,
      answer,
    } = this.props;
    const { file } = this.state;
    const answerYes = answer && answer.EmployeeDetailAgreementAnswer === 1;
    const actions = [
      <RaisedButton
        onClick={this.onAccept}
        primary
        label={<FormattedMessage id="agreement.yes" />}
        style={styles.action}
      />,
      <RaisedButton
        onClick={this.handleClose}
        label={<FormattedMessage id="agreement.no" />}
        style={styles.action}
      />,
    ];
    return (
      <Paper data-cy="agreement-paper" style={{ ...styles.agreementItem, borderLeftColor: answerYes ? pallet.successColor : pallet.warningColor }}>
        <Dialog
          actions={actions}
          modal
          open={this.state.dialogOpen}
          onRequestClose={this.handleClose}
        >
          <FormattedMessage id="agreement.dialog" />
        </Dialog>
        <p dangerouslySetInnerHTML={{ __html: HrAgreementText }} />
        {(FileRepositoryObjectDocumentTypeID !== 0 && !answerYes) &&
          <div>
            <input type="file" onChange={this.handleFile} />
            {!file && <span style={styles.warning}><FormattedMessage id="agreement.noFile" /></span>}
          </div>
        }
        {Link &&
          <div style={styles.infoButton}>
            <RaisedButton
              target="_blank"
              label={<FormattedMessage id="agreement.moreInfo" />}
              href={Link}
            />
          </div>
        }
        <div style={styles.acceptContainer}>
          <Checkbox
            checked={answerYes}
            disabled={!file && FileRepositoryObjectDocumentTypeID !== 0 && !answerYes}
            onCheck={this.onCheck}
            label={
              <FormattedMessage id="agreement.sign" />
            }
          />
        </div>
      </Paper>
    );
  }
}

Agreement.propTypes = {
  HrAgreementText: PropTypes.string.isRequired,
  HrAgreementID: PropTypes.number.isRequired,
  FileRepositoryObjectDocumentTypeID: PropTypes.number.isRequired,
  EmployeeDetailID: PropTypes.string.isRequired,
  Link: PropTypes.string,
  handleAgreement: PropTypes.func.isRequired,
  answer: PropTypes.object,
};

export default Agreement;



// WEBPACK FOOTER //
// ./src/components/Agreement.js